const ConversaoCambio = require('./ConversaoCambio');
const floatToMoney = require('../functions/floatToMoney');

/**
 * Inicializa a função de câmbio de de despesas
 */
function CambioDespesa() {
  const wrapperInputsCambio = document.querySelector('.inputs-cambio__wrapper');

  if (!document.body.contains(wrapperInputsCambio)) {
    return;
  }

  settings(wrapperInputsCambio);
}

/**
 * Realiza a inicialização das funções de câmbio da despesa
 *
 * @param {Element} wrapperInputsCambio
 */
function settings(wrapperInputsCambio) {
  const form = wrapperInputsCambio.closest('form');
  applyListenersInputsControlExchangeInput(form);

  if (!wrapperInputsCambio.classList.contains('hidden')) {
    applyListenersInputsExchangeValue(form);
  }
}

/**
 * Aplica o listener nas inputs que controla a necessidade
 * de utilizar as inputs câmbio atualmente (idMoeda, idPagamentoForma)
 *
 * @param {Element} form
 */
function applyListenersInputsControlExchangeInput(form) {
  const inputCurrency = form.querySelector('#idMoeda');
  const inputPaymentMethod = form.querySelector('#idPagamentoFormaDespesa');
  handlerApplyControlExchangeInputs(null, form);

  inputCurrency.addEventListener('change', handlerApplyControlExchangeInputs);
  inputPaymentMethod.addEventListener('change', handlerApplyControlExchangeInputs);
}

/**
 * Aplica o listener das inputs que são responsáveis por
 * efetuar os cálculos de câmbio
 *
 * @param {Element} form
 */
function applyListenersInputsExchangeValue(form) {
  const inputValue = form.querySelector('#valor');
  const inputRate = form.querySelector('#taxaCambial');
  const inputConverted = form.querySelector('#valorConvertido');

  inputValue.addEventListener('keyup', (event) => {
    if (!ConversaoCambio.validKeyPress(event)) { return };
    ConversaoCambio.keyupEvent(event, handlerCalculateExchageValuesFromExpense);
  });

  inputRate.addEventListener('keyup', (event) => {
    event.target.value = ConversaoCambio.formatExchangeRate(event.target.value);
    if (!ConversaoCambio.validKeyPress(event)) { return };
    ConversaoCambio.keyupEvent(event, handlerCalculateExchangeValueFromRate);
  });

  inputConverted.addEventListener('keyup', (event) => {
    if (!ConversaoCambio.validKeyPress(event)) { return };
    ConversaoCambio.keyupEvent(event, handlerCalculateExchangeValueFromConverted);
  });
}

/**
 * Método responsável por aplicar o cálculo do câmbio quando a input
 * de valor da despesa estiver sofrendo alteração no valor informado
 * nela (usuário estiver digitando)
 *
 * @param {Event} event
 */
function handlerCalculateExchageValuesFromExpense(event) {
  const form = event.target.closest('form');
  const inputValue = form.querySelector('#valor');
  const inputRate = form.querySelector('#taxaCambial');
  const inputConverted = form.querySelector('#valorConvertido');
  const changeRate = inputConverted.getAttribute('modify-exchange-value');

  const value = ConversaoCambio.stringToFloat(inputValue.value);
  const rate = ConversaoCambio.stringToFloat(inputRate.value);
  const converted = ConversaoCambio.stringToFloat(inputConverted.value);

  // Caso tenhamos um valor de taxa de câmbio, o valor convertido
  // será cálculado
  if (inputRate.value !== '' && inputValue.value !== '') {
    const converted = ConversaoCambio.calculate(rate, value, '*', 2);
    return $(inputConverted).val(floatToMoney(converted));
  }

  // Caso a input do valor convertido tenha um valor dentro dela,
  // a taxa de câmbio será calculada
  if (inputConverted.value !== '' && changeRate === 'true') {
    const rate = ConversaoCambio.calculate(converted, value, '/', 5);
    // Formatando o valor da input de taxa
    inputRate.value =  ConversaoCambio.formatExchangeRate(rate);
  }
}

/**
 * Método responsável por aplicar o cálculo de câmbio quando a input
 * de taxa estiver sofrendo alterações em seu valor (usuário estiver digitando)
 *
 * @param {Event} event
 */
function handlerCalculateExchangeValueFromRate(event) {
  const form = event.target.closest('form');
  const inputValue = form.querySelector('#valor');
  const inputRate = form.querySelector('#taxaCambial');
  const inputConverted = form.querySelector('#valorConvertido');

  if (inputValue.value !== '' && inputRate.value !== '') {
    const value = ConversaoCambio.stringToFloat(inputValue.value);
    const rate = ConversaoCambio.stringToFloat(inputRate.value);
    const converted = ConversaoCambio.calculate(rate, value, '*', 2);
    $(inputConverted).val(floatToMoney(converted));
  }
}

/**
 * Método responsável por aplicar o cálculo de câmbio quando a input de valor
 * convertiddo estiver sofrendo alterações em seu valor (usuário estiver digitando)
 * @param {Event} event
 */
function handlerCalculateExchangeValueFromConverted(event) {
  const form = event.target.closest('form');
  const inputValue = form.querySelector('#valor');
  const inputRate = form.querySelector('#taxaCambial');
  const inputConverted = form.querySelector('#valorConvertido');
  const changeRate = inputConverted.getAttribute('modify-exchange-value');

  const value = ConversaoCambio.stringToFloat(inputValue.value);
  const converted = ConversaoCambio.stringToFloat(inputConverted.value);
  const rate = ConversaoCambio.stringToFloat(inputRate.value);
  // Se não for uma despesa de cartões, será alterado o input da taxa
  if (inputValue.value !== '' && changeRate === 'true') {
    const rate = ConversaoCambio.calculate(converted, value, '/', 5);
    // Formatando o valor da input de taxa
    inputRate.value = ConversaoCambio.formatExchangeRate(rate);
  }

  // Se não alterará o input de valor
  if (inputRate.value !== '' && changeRate === 'false') {
    const value = ConversaoCambio.calculate(converted, rate, '/', 2);
    // Formatando o valor do input de valor
    inputValue.value = ConversaoCambio.formatExchangeRate(value);
  }
}

/**
 * Aplica as regras de controle sobre as inputs de conversão de
 * câmbio aplicando as regras de negócio para determinar so câmbio
 * deve ser adicionado ao formulário ou não
 */
function handlerApplyControlExchangeInputs(event, form) {
  if(event) {
    form = event.target.closest('form');
  }

  const inputCurrency = form.querySelector('#idMoeda');
  const inputPaymentMethod = form.querySelector('#idPagamentoFormaDespesa');

  const idMoedaPadraoEmpresa = form.querySelector('#idMoedaEmpresa').value;
  const companyUseExchangeExpense = form.dataset.companyUseExchangeValue;
  const dataPaymentMethodsUseExchange = JSON.parse(inputPaymentMethod.dataset.pagamentoFormasCambio);
  const idPaymentMethodSelected = inputPaymentMethod.value;
  const companyBlockedMulticurrency = form.dataset.multicurrencyBlocked;

  // Se a empresa não utiliza câmbio não será aplicada interação com os câmpos de câmbio
  if (companyUseExchangeExpense === 'NAO_UTILIZA') {
    return;
  }

  // Se moeda de lançamento da despesa for igual a moeda padrão utiliza pela empresa,
  // não será necessário o uso dos campos de câmbio, logo eles serão resetados e removidos
  if (inputCurrency.value === idMoedaPadraoEmpresa) {
    return enableOrDisableInputsExchangeFields(false, form, companyBlockedMulticurrency);
  }

  // Se a empresa exige o câmbio os campos de câmbio serão inicializados
  if (companyUseExchangeExpense === 'SEMPRE_EXIGE') {
    return enableOrDisableInputsExchangeFields(true, form, companyBlockedMulticurrency);
  }

  // Se a empresa exige o campo apenas em determinadas formas de pagamento
  // se a forma de pagamento selecionada for uma das que a empresa solicita o
  // câmbio os campos serão incializados
  const paymentMethodsUseExchange = dataPaymentMethodsUseExchange[idPaymentMethodSelected];
  if (companyUseExchangeExpense === 'FORMA_DE_PAGAMENTO' && paymentMethodsUseExchange) {
    return enableOrDisableInputsExchangeFields(true, form, companyBlockedMulticurrency);
  }

  // Por padrão se nenhum das opções acima forem satisfeitas os campos
  // de câmbio são resetados e removidos
  return enableOrDisableInputsExchangeFields(false, form, companyBlockedMulticurrency);
}

/**
 * Método responsável por incializar ou resetar os campos de câmbio
 * do formulário de despesas
 *
 * @param {bool} enable
 * @param {Element} form
 */
function enableOrDisableInputsExchangeFields(enable, form, require) {
  const inputExchangeRate = form.querySelector('#taxaCambial');
  const inputConvertedValue = form.querySelector('#valorConvertido');
  const wrapperInputsCambio = form.querySelector('.inputs-cambio__wrapper');

  if (require) {
    // Determinando se os campos de câmbio são requeridos na validação
    inputExchangeRate.setAttribute('data-rule-required', enable);
    inputExchangeRate.setAttribute('data-rule-exchange-value', enable);

    inputConvertedValue.setAttribute('data-rule-required', enable);
  }

  // Desabilitando as inpuits de câmbio para não serem enviadas
  // no submit do formulário
  inputExchangeRate.disabled = !enable;
  inputConvertedValue.disabled = !enable;

  // Aplicando o listener de converão de valores nos campos de câmbio e
  // exibindo os campos dentro do fomulário
  if (enable) {
    applyListenersInputsExchangeValue(form);
    return wrapperInputsCambio.classList.remove('hidden');
  }

  // Ocultando os campos de câmbio de dentro do formulário
  wrapperInputsCambio.classList.add('hidden');

  // Limpando os valores que podem ter sido digitados nos campos de
  // câmbio antes de eles serem ocultados e
  inputExchangeRate.value = '';
  inputConvertedValue.value = '';
}

module.exports = {
  init: CambioDespesa
};
